import React from "react";
import styles from "./AssessmentIntro.module.css";
import { ShieldIcon, ClockIcon, EyeIcon } from "../icons/icons";

/* Landing screen — mirrors the supplied design: eyebrow, headline with an
   underlined accent word, lede, meta row, confidential note and CTA. */
const AssessmentIntro = ({ intro, onBegin, variant = "default" }) => {
  const { eyebrow, heading, highlight, description, durationLabel, questionsLabel, confidentialNote, ctaLabel } = intro;
  const isAssessment2 = variant === "assessment2";

  // Split the headline so the highlighted word gets the underline accent.
  const renderHeading = () => {
    if (!highlight || !heading.includes(highlight)) return heading;
    const [before, after] = heading.split(highlight);
    return (
      <>
        {before}
        <span className={styles.headingMark}>{highlight}</span>
        {after}
      </>
    );
  };

  if (isAssessment2) {
    return (
      <div className={styles.assessmentTwoIntro}>
        <div className={styles.assessmentTwoCopy}>
          <h1 className={styles.assessmentTwoHeading}>
            Is your Practice ready for{" "}
            <span>
              what<span className={styles.altGlyph}>&rsquo;</span>s next?
            </span>
          </h1>
          <span className={styles.assessmentTwoRule} aria-hidden="true" />
          <p className={styles.assessmentTwoText}>
            Answer a few quick questions to explore if
            Deseyne EDOF may be a fit for your team.

          </p>
          <button type="button" className={styles.assessmentTwoBtn} onClick={onBegin}>
            {/* <span aria-hidden="true">-&gt;</span> */}
            Get Your Practice Snapshot →
          </button>
          {/* <div className={styles.assessmentTwoTime}>
            <span>Takes about 2 minutes</span>
          </div> */}
          <div className={styles.assessmentTwoBadges}>
            <span>
              <ClockIcon />
              Takes 2 minutes
            </span>
            <span>
              <ShieldIcon />
              Confidential & secure
            </span>
            <span>
              <EyeIcon />
              For eye care professionals
            </span>
          </div>
        </div>

        <div className={styles.assessmentTwoVisual} aria-hidden="true">
          <img src="/Images/practice_assessment_new.webp" alt="practice_assessment_new" />
          <img className={styles.assessmentTwoLogo} src="/Images/Deseyne Logo.webp" alt="Deseyne EDOF" />
          <div className={styles.assessmentTwoPreview}>
            <span className={styles.previewSheen} aria-hidden="true" />
            <h3>Practice Snapshot Preview</h3>
            <p>
              <span className={styles.previewIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 21h18" />
                  <path d="M6 21v-3" />
                  <path d="M10 21v-5" />
                  <path d="M14 21v-3" />
                  <path d="M18 21v-6" />
                  <path d="M4 13l4-3 4 2 8-7" />
                  <path d="M17 5h3v3" />
                </svg>
              </span>
              <b>Growth Opportunity</b>
              <span>See how your practice can benefit from less chair time and improved patient sentiment.</span>
            </p>
            <p>
              <span className={styles.previewIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
                </svg>
              </span>
              <b>Reduce Friction</b>
              <span>Find out how Deseyne addresses common fitting challenges in a completely new way.</span>
            </p>
            <p>
              <span className={styles.previewIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </span>
              <b>Fitting Sets</b>
              <span>Get connected with our team and bring EDOF to your patients.</span>
            </p>
          </div>
        </div>


      </div>
    );
  }

  return (
    <div className={`${styles.intro} ${isAssessment2 ? styles.introTwo : ""}`}>
      <span className={styles.eyebrow}>{eyebrow}</span>
      <h1 className={styles.heading}>{renderHeading()}</h1>
      <p className={styles.lede}>{description}</p>

      <div className={styles.meta}>
        <span>
          <ClockIcon /> <span className={styles.metaStrong}>{durationLabel}</span>
        </span>
        <span>
          <span className={styles.metaStrong}>{questionsLabel}</span>
        </span>
      </div>

      <div className={styles.note}>
        <ShieldIcon />
        <span>{confidentialNote}</span>
      </div>

      <div className={styles.introCta}>
        <button type="button" className={`${styles.btn} ${styles.btnPrimary}`} onClick={onBegin}>
          {ctaLabel}
        </button>
      </div>
    </div>
  );
};

export default AssessmentIntro;
